import React from 'react';
const ArrowRight = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M288.791335 65.582671l446.41733 446.417329-446.41733 446.417329z" p-id="12695"></path>
  </svg>
);
export default ArrowRight;
